var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SearchBox02'),_c('Content01')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }